import { useIntl } from "react-intl";

import PresenceActiveIcon from "@atlaskit/icon/glyph/presence-active";

import Link from "@/components/wpl/link/src";
import { useLocalizedHref } from "@/libraries/web-framework";

import { tabbedHeroSectionWhiteboardsMessages } from "../messages/tabbed-hero-section.messages";

import { ContentTypeVideo } from "./content-type-video";

export const WhiteboardsContentType = () => {
    const intl = useIntl();
    const ctaLink = useLocalizedHref("/software/confluence/whiteboards");

    return (
        <ContentTypeVideo
            title={intl.formatMessage(
                tabbedHeroSectionWhiteboardsMessages.contentTitle
            )}
            description={intl.formatMessage(
                tabbedHeroSectionWhiteboardsMessages.contentDescription
            )}
            iconTitle={intl.formatMessage(
                tabbedHeroSectionWhiteboardsMessages.contentIconTitle
            )}
            iconCollection={[
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionWhiteboardsMessages.contentFeaturePoint1
                    ),
                    icon: <PresenceActiveIcon size="small" label="" />
                },
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionWhiteboardsMessages.contentFeaturePoint2
                    ),
                    icon: <PresenceActiveIcon size="small" label="" />
                },
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionWhiteboardsMessages.contentFeaturePoint3
                    ),
                    icon: <PresenceActiveIcon size="small" label="" />
                }
            ]}
            cta={
                <Link
                    href={ctaLink}
                    text={intl.formatMessage(
                        tabbedHeroSectionWhiteboardsMessages.contentCta
                    )}
                    type={"basic"}
                    doesArrowAnimate={true}
                    dataEventProps={{
                        "data-product-key": "confluence",
                        "data-event-component": "linkButton",
                        "data-event-container": "contentTypesSection",
                        "data-event": "clicked",
                        "data-label": "explore-whiteboards",
                        "data-label-english": "Explore Whiteboards",
                        "data-track-event":
                            "confluence-pt.content-types.whiteboards.cta"
                    }}
                />
            }
            reverseLayout
            videoSrc="https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Whiteboards_LowBR.webm"
            videoPreviewSrc="https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Whiteboards_Preview.webp"
        />
    );
};
